import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { DeleteStudentService } from '../../services/competitions';
import { getMixpanelAdminType, Mixpanel } from '../../services/Mixpanel';
import { textIdentifier } from '../../textIdentifier';

const DeleteStudentModal = ({ students, setShowDeleteStudentModal }) => {
	const [showConfirmation, setShowConfirmation] = useState(false);
  const [search, setSearch] = useState("");
  const [filteredStudents, setFilteredStudents] = useState(students || [])
	const [selectedStudentToDelete, setSelectedStudentToDelete] = useState(null);
	const { selectedCompetition, selectedClass,lang } = useSelector(
		(state) => state.main
	);
	const { userData } = useSelector((state) => state.auth);
	const deleteStudent = async () => {
		try {
			const res = await DeleteStudentService(
				selectedClass.code,
				selectedStudentToDelete.id
			);
			setShowConfirmation(false);
			setShowDeleteStudentModal(false);
			Mixpanel.track("Competition_Admin_Student_Deleted", {
				"Admin_Type": getMixpanelAdminType(userData.groups),
				"CompetitionID": selectedCompetition?.id,
				"CompetitionName": selectedCompetition?.name,
				"Student_id": selectedStudentToDelete?.id,
			});
      Mixpanel.people.set({
        "$email": userData?.email,
        "$distinct_id": userData?.id
      });
		} catch (e) {
			console.error("Error fetching students: ", e);
		}
	};

  const handleFilter = (text) => {
    setSearch(text);
    setFilteredStudents(
      students.filter((s) => {
        return (
          s.first_name?.toLowerCase().includes(text?.toLowerCase()) ||
          s.last_name?.toLowerCase().includes(text?.toLowerCase()) ||
          s.email?.toLowerCase().includes(text?.toLowerCase())
        );
      })
    );
  };

  return !showConfirmation ? (
    <div
      className="modal fade show"
      id="deleteStudentModal"
      tabindex="-1"
      aria-labelledby="Delete Student Modal"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-body">
            <span className="modal-title">{textIdentifier["delete-student"][lang]}</span>

            <form autoComplete='off'>
              <div className="form-group">
                <div className="dropdown">
                  <input
                    id="selectStudentDropdown"
                    className="px-2 w-100"
                    placeholder= {textIdentifier["select-student"][lang]}
                    onChange={(e) => handleFilter(e.target.value)}
                    value={search}
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{ fontWeight: "bold" }}
                  />

                  <ul
                    className="dropdown-menu"
                    aria-labelledby="selectStudentDropdown"
                  >
                    <div className="list-group list-group-flush dropdown-inner-container">
                      {filteredStudents.map((student) => (
                        <li
                          className="dropdown-item list-group-item"
                          onClick={() => {
                            setSearch(
                              `${student.first_name} ${student.last_name}`
                            );
                            setSelectedStudentToDelete(student);
                          }}
                          style={{ maxHeight: "60px" }}
                          key={student.id}
                        >
                          {(!!student.first_name ? student.first_name : "") +
                            " " +
                            (!!student.last_name ? student.last_name : "")}
                          {` (${!!student.email ? student.email : ""})`}
                        </li>
                      ))}
                    </div>
                  </ul>
                </div>

                {!selectedStudentToDelete && (
                  <div id="helperText" className="form-text mt-1">
                    {textIdentifier["please-select-a-student"][lang]}
                  </div>
                )}
              </div>

              <div className="btn-container">
                <button
                  type="button"
                  className="btn-outlined w-50"
                  onClick={() => setShowDeleteStudentModal(false)}
                >
                  {textIdentifier["cancel"][lang]}
                </button>
                <Link
                  data-bs-toggle="modal"
                  data-bs-target="#deleteConfirmationModal"
                  to="#deleteConfirmationModal"
                >
                  <button
                    type="button"
                    className="btn-contained"
                    onClick={() => setShowConfirmation(true)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="18"
                      viewBox="0 0 18 20"
                      fill="none"
                    >
                      <path
                        d="M1 5H17M16 5L15.133 17.142C15.0971 17.6466 14.8713 18.1188 14.5011 18.4636C14.1309 18.8083 13.6439 19 13.138 19H4.862C4.35614 19 3.86907 18.8083 3.49889 18.4636C3.1287 18.1188 2.90292 17.6466 2.867 17.142L2 5H16ZM7 9V15V9ZM11 9V15V9ZM12 5V2C12 1.73478 11.8946 1.48043 11.7071 1.29289C11.5196 1.10536 11.2652 1 11 1H7C6.73478 1 6.48043 1.10536 6.29289 1.29289C6.10536 1.48043 6 1.73478 6 2V5H12Z"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span className="text-white">{textIdentifier["delete"][lang]}</span>
                  </button>
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div
      className="modal fade show"
      id="deleteConfirmationModal"
      tabindex="-1"
      aria-labelledby="Delete Confirmation Modal"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-body">
            <span className="heading">
              {textIdentifier["are-you-sure-you-want-to-delete"][lang]}{" "}
              {(!!selectedStudentToDelete.first_name
                ? selectedStudentToDelete.first_name
                : "") +
                " " +
                (!!selectedStudentToDelete.last_name
                  ? selectedStudentToDelete.last_name
                  : "")}
              {` (${
                !!selectedStudentToDelete.email
                  ? selectedStudentToDelete.email
                  : ""
              })`}
              , {textIdentifier["progress-if-any-would-be-lost"][lang]}?
            </span>

            <div className="btn-container">
              <button
                type="button"
                className="btn-outlined"
                onClick={() => setShowDeleteStudentModal(false)}
              >
                {textIdentifier["cancel"][lang]}
              </button>
              <button
                type="submit"
                className="btn-contained"
                onClick={deleteStudent}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 18 20"
                  fill="none"
                >
                  <path
                    d="M1 5H17M16 5L15.133 17.142C15.0971 17.6466 14.8713 18.1188 14.5011 18.4636C14.1309 18.8083 13.6439 19 13.138 19H4.862C4.35614 19 3.86907 18.8083 3.49889 18.4636C3.1287 18.1188 2.90292 17.6466 2.867 17.142L2 5H16ZM7 9V15V9ZM11 9V15V9ZM12 5V2C12 1.73478 11.8946 1.48043 11.7071 1.29289C11.5196 1.10536 11.2652 1 11 1H7C6.73478 1 6.48043 1.10536 6.29289 1.29289C6.10536 1.48043 6 1.73478 6 2V5H12Z"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className="text-white">{textIdentifier["yes"][lang]}, {textIdentifier["delete"][lang]}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteStudentModal;
